import React, { useState } from "react";

import { useNotify, SaveButton } from "react-admin";
import { useForm } from "react-final-form";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { getCustomFieldsToSave } from "../../../components/common/CustomFields";
import { logError, logHistory } from "../../../utils/appUtils";
import {
  InventoryStatus,
  ResourceType,
  Unit,
  UnitToColumn,
} from "../../../utils/constants";
import { deepRedirect } from "../../../utils/utils";
import { handleValidateSave } from "./ProductUtils";
import { sanitizeProduct } from "../../../graphql/account/accountCRUD";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

export const ValidateCreateButton = (props) => {
  const form = useForm();
  const notify = useNotify();
  const classes = useStyles();
  const [saving, setSaving] = useState(false);
  const { backPath, history, savedRecord, account } = props;

  const transform = (data) => {
    try {
      debugger;
      data = { ...data };
      const unitEntries = Object.entries(UnitToColumn).filter(
        (e) => e[0] !== Unit.CAR && e[0] !== Unit.TL,
      );

      data.active = "true";
      data.reloadYardId = window.appUser?.reloadYardId;
      data.groups = window.appUser?.groups;
      data.status = InventoryStatus.STORED; // used for inventories connection

      data.height = parseFloat(data["height"]);
      data.width = parseFloat(data["width"]);
      data.length = parseFloat(data["length"]);

      unitEntries.forEach(([unit, column]) => {
        data[column] = parseFloat(data[column]);
      });

      data.totalQuantityOnHand = 0;
      data.totalQuantityCommitted = 0;
      data.lowInventoryAlert = false;

      data.customFields = getCustomFieldsToSave(
        data.customFields,
        account.inventoryCustomFields,
      );
    } catch (err) {
      logError("products:ValidateCreateButton:transform", err, notify);
      setSaving(false);
      return Promise.reject();
    }

    data = sanitizeProduct(data);
    delete data.accountName; // cleanup side-effects
    delete data.id; // required for cloning

    return data;
  };

  const onSuccess = async ({ data }) => {
    debugger;
    logHistory({
      parentId: data.id,
      parentType: ResourceType.PRODUCT,
      text: "Product created.",
    });

    notify(`Product created successfully.`);
    setSaving(false);
    deepRedirect(history, backPath, null, {
      account: account,
      savedRecord: savedRecord,
    });
  };

  const onFailure = (error) => {
    debugger;
    setSaving(false);
    logError("product:ValidateCreateButton:onFailure", error, notify);
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={saving}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <SaveButton
        label="Save"
        saving={saving}
        undoable={false}
        handleSubmitWithRedirect={handleValidateSave(
          form,
          setSaving,
          props.handleSubmitWithRedirect,
          notify,
        )}
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    </>
  );
};
